module.exports = __webpack_public_path__ + "img/linkedin-login.a5fc61b1.svg";